import {css} from 'lit';
export const styles = css`:host{display:block;height:100%}.table-wrapper{overflow:auto;border:1px solid var(--bl-color-neutral-lighter);border-radius:var(--bl-size-3xs);position:relative;max-height:100%}.table{width:100%;display:table;border-spacing:0}`;
export default styles;
